import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner, Alert } from "react-bootstrap";
import { API } from 'aws-amplify';
import { getAuthToken } from '../../../utils/AuthUtils';
import DataGrid from 'react-data-grid';
import './styles.scss';


const parseCompanies = (compensationIds) => {
    const companies = new Map();
    if (!compensationIds || compensationIds.length === 0) {
        return companies;
    }

    for (const id of compensationIds) {
        const parts = id.split("#");
        const companyName = parts[0];
        const ticker = parts[1];
        const exchange = parts[5];
        let tickerWithExchange;
        if (exchange && exchange !== "NO_EXCHANGE") {
            tickerWithExchange = `${exchange}:${ticker}`;
        } else {
            tickerWithExchange = ticker;
        }
        companies.set(tickerWithExchange, { companyName, tickerWithExchange });
    }
    const companiesArr = Array.from(companies.values());
    return companiesArr.sort((a, b) => a.companyName.localeCompare(b.companyName));
}

const SaveCompanyListModal = ({ show, companyIds, onClose }) => {
    const [saving, setSaving] = useState(false);
    const [title, setTitle] = useState("");
    const [notes, setNotes] = useState("");
    const [selectedCompanies, setSelectedCompanies] = useState(parseCompanies(companyIds));
    const [showSuccess, setShowSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [sortColumns, setSortColumns] = useState([]);

    const handleClose = () => {
        setSaving(false);
        setTitle("");
        setNotes("");
        setShowSuccess(false);
        setError(false);
        setErrorMessage("");
        setSelectedCompanies([]);
        setSortColumns([]);
        onClose();
    }

    const columns = [
        {
            key: "companyName",
            name: 'Company Name',
            sortable: true,
            filterable: true,
            frozen: true,
        },
        {
            key: "tickerWithExchange",
            name: 'Ticker',
            sortable: true,
            filterable: true,
            frozen: true,
        }
    ]

    const handleSave = async () => {
        const authToken = await getAuthToken();
        const companyList = selectedCompanies.map((company) => company.tickerWithExchange);

        if (!title) {
            setError(true);
            setErrorMessage("Please enter a title");
            return;
        }

        const body = {
            companyList,
            title,
            notes
        }
        setSaving(true);
        setError(false);
        setErrorMessage("");
        setShowSuccess(false);


        await API.put('AnnualCompensations', '/custom-company-list', {
            headers: {
                'Token': authToken
            },
            body
        }).then((response) => {
            setSaving(false);
            setShowSuccess(true);
        }).catch((error) => {
            if (error?.response?.data?.message) {
                console.log(error.response.data.message);
            } else {
                console.log(error);
                console.log("An error occurred while retrieving client data requsts. Please try again later.");
            }
            setSaving(false);
            setError(true);
            setErrorMessage("An error occurred while retrieving client data requsts. Please try again later.")
        })
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            setSaving(false);
            setTitle("");
            setNotes("");
            setError(false);
            setErrorMessage("")
            setShowSuccess(false);
            setSelectedCompanies(parseCompanies(companyIds))
        }
        return () => { isMounted = false };
    }, [show, companyIds]);

    return (
        <Modal show={show} onHide={handleClose} size='lg' centered dialogClassName="dashboard-modal">
            <div className='save-company-list-container'>
            <Modal.Header closeButton>
                <Modal.Title>
                    Save Company List
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="title">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            type="text"
                        />
                    </Form.Group>
                    <Form.Group controlId="notes">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            as="textarea"
                        />
                    </Form.Group>
                </Form>
                <div className='ticker-list'>
                    <DataGrid
                        className={'grid rdg-light filter-container'}
                        columns={columns}
                        rows={selectedCompanies}
                        sortColumn={sortColumns}
                        onSortColumnsChange={setSortColumns}
                    />
                </div>
                {showSuccess && <Alert variant="success" dismissible>Successfully saved company list</Alert>}
                {error && <Alert variant="danger" dismissible>{errorMessage}</Alert>}
            </Modal.Body>
            <Modal.Footer>
                {saving ? <Button variant="btn btn-primary"
                    style={{ "width": "20%" }}
                    disabled={true}>
                    <output>Saving...</output>
                    <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        aria-hidden="true"
                    />
                </Button> :
                    <Button variant="btn btn-primary" onClick={handleSave} style={{ "width": "20%" }} disabled={saving}>
                        Save
                    </Button>}
                <Button variant="btn btn-secondary" onClick={handleClose} style={{ "width": "20%" }} disabled={saving}>
                    Close
                </Button>
                </Modal.Footer>
                </div>
        </Modal>
    )
}

export default SaveCompanyListModal;
